import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import './style.scss'
import { ReactComponent as SVGLogoBanner } from 'assets/svgs/banner-logo.svg'
import MultiLanguage from 'components/multi language'
import UserConnect from 'components/user-connect'
import { useSelector } from 'react-redux'
import { selectWallet } from 'store/wallet/selectors'
import { useTranslation } from 'react-i18next'

export default function Header() {
  const { address } = useSelector(selectWallet)
  const { t } = useTranslation()

  return (
    <header className='header'>
      <div className='header__left'>
        <Link to='/' className='header__logo'>
          <SVGLogoBanner />
        </Link>
      </div>

      <div className='header__center'>
        {!!address && (
          <div className='header__menu'>
            <NavLink to='/whitelist' className='header__menu__item'>
              {t('WHITELIST')}
            </NavLink>
            <NavLink to='/manages-artist' className='header__menu__item'>
              {t('MANAGER_ARTIST')}
            </NavLink>
          </div>
        )}
      </div>

      <div className='header__right'>
        <MultiLanguage />
        <UserConnect />
      </div>
    </header>
  )
}
